import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

export const useCommonOAuthRedirect = ({
  type = 'CP_SELF_SCHEDULE',
  status = 'SUCCESS',
  reason = null,
  message = null,
  autoRedirect = false,
}) => {
  const [searchParams] = useSearchParams();
  const [showContinueButton, setShowContinueButton] = useState(false);
  const dispatch = useDispatch();
  const isValidDomain = useCallback((url) => {
    try {
      const { hostname, protocol } = new URL(url);
      return ['http:', 'https:'].includes(protocol) && 
             (hostname.endsWith('walmart.com') || hostname.endsWith('wal-mart.com') || 
              hostname.endsWith('walmart.net') || hostname.endsWith('wal-mart.net'));
    } catch {
      return false;
    }
  }, []);

  const getRedirectUrl = useCallback(() => {
    const rawUrl = sessionStorage.getItem('ssRedirectUrl') || sessionStorage.getItem('redirectUrl');
    const sanitizedUrl = rawUrl?.trim()?.replace(/[<>"']/g, '');
    return sanitizedUrl && isValidDomain(sanitizedUrl) ? sanitizedUrl : null;
  }, [searchParams, isValidDomain]);

  const performRedirect = useCallback((url) => {
    const cpStatus = JSON.stringify({
      type,
      status,
      ...(reason && { reason }),
      ...(message && { message })
    });
    const separator = url.includes('?') ? '&' : '?';
    window.location.href = `${url}${separator}cp-status=${window.btoa(encodeURIComponent(cpStatus))}`;
  }, [type, status, reason, message]);

  const handleContinueRedirect = useCallback(() => {
    const validUrl = getRedirectUrl();
    if (validUrl) {
      performRedirect(validUrl);
    }
  }, [getRedirectUrl, performRedirect]);

  useEffect(() => {
    if (autoRedirect ) {
      handleContinueRedirect();
    }else if(getRedirectUrl()){
      setShowContinueButton(true);
    }
  }, []);

  return {
    showContinueButton,
    handleContinueRedirect
  };
};
